import React from "react";
import MainPagetitle from "../../layouts/MainPagetitle";

export const TermsAndConditions = () => {
  return (
    <>
      <MainPagetitle
        mainTitle="Terms & Conditions"
        pageTitle="Terms & Conditions"
        parentTitle="Home"
      />
      <div className="container-fluid cert_docs_container">
        <div class="card p-4">
          <h2 class="modal-title mb-3">Terms and conditions</h2>
          <b>Please review the Terms and Conditions before proceeding.</b>

          <p>
            By clicking "I agree" or "I accept," or by downloading, installing,
            or using the services, you are indicating your agreement to the
            terms and conditions outlined in this document. If you do not agree
            to these terms and conditions, please refrain from clicking "I
            agree", downloading, installing, or using the services. This is a
            legally binding agreement between Ayaan Finserve India Pvt Limited
            and yourself.
          </p>

          <b>DEFINITIONS:</b>
          <p>
            The term "Application" refers to the mobile app and website
            developed by our company, designed to provide end-users with access
            to AFI- Dhanvriddhi. "Lender" refers to Ayaan Finserve India Pvt
            Ltd. The lender is responsible for approving, processing, and
            disbursing loans to customers through our platform. "We" refers to
            Ayaan Finserve India Pvt Ltd, a Delhi-based NBFC.
          </p>

          <p>
            The term "loan" refers to the financial assistance that you can
            apply for through our Platform. The loan is approved and provided by
            the Lender, subject to specific terms and conditions. The "Loan
            Agreement" denotes the agreement between the Lender and the
            customer, which may be in physical or digital form. The "App"
            represents the mobile app and website regularly made available to
            end-users.
          </p>

          <p>
            Accuracy, correctness, and completeness. The "outstanding amount"
            encompasses the loan, interest, and fees owed by you to the Lender
            on the due date. The "Platform" refers to both the mobile app and
            website. The "services" pertain to the Lender's ability to grant,
            approve, and provide short-term loans through the platform.
            "Third-party platforms" are social networking sites such as LinkedIn
            and Facebook. "User data" refers to any information, documents, or
            materials provided by you to our company. Finally, the "Website"
            corresponds to our company's online platform.
          </p>

          <b>SERVICES:</b>
          <p>
            Our Services allow you to apply for a loan if you meet the
            requirements specified within the app. By utilizing our service, you
            acknowledge and agree that our company is responsible for
            collecting, verifying, tracking your location, confirming, and
            validating the User Data, Documents, and any other information
            required by the Lender to approve the loan. You grant the Lender
            permission to allow our company to collect and store your User Data
            through the mobile app and website Application Form available on the
            Platform.
          </p>

          <p>
            To access the Services, you will need to register and log in through
            your third-party platform account. During the application process,
            you will be required to submit and upload user information using the
            mobile app and website form. This information includes your name,
            email address, gender, and date of birth. Additionally, you will
            need to provide a password, a photograph, a contact number, your
            mobile phone number, and your login credentials from the third-party
            platform. This information also encompasses financial details such
            as bank statements, income, bank account numbers, PAN cards, data
            necessary for customer compliance, data from credit information
            companies, and any other relevant information important to you. By
            signing up for these Services, you authorize us to import your
            personal information from other platforms. You acknowledge that we
            may request updates on your personal information periodically to
            ensure a The Company undertakes all actions on your behalf with your
            explicit permission and strictly adheres to non-discriminatory
            practices. By granting permission, you authorize the Company to
            request your credit information from one or more credit information
            companies as required. Once you have verified and uploaded your User
            information and/or other relevant information in the MOF (mobile app
            and website Application Form), the Company will proceed with the
            necessary verification procedures. Upon successful verification, you
            may become eligible for loan approval by the Lender, subject to the
            lender's specific eligibility criteria and conditions. Subsequently,
            you will be required to complete additional forms such as the ECS
            (Electronic Clearing Service) or NACH (National Automated Clearing
            House) mandate, provide a check, or any other documentation
            requested by the lender. The Company may also collect physical
            documents, including signatures, that are essential for approval and
            processing. Once the required documents have been collected, the
            lender will disburse the loan amount in accordance with the terms
            outlined in the loan agreement.
          </p>

          <p>
            The approved loan amount will be disbursed to you based on the
            instructions provided in your mobile app and website application. It
            is your responsibility to repay the loan amount to the lender on the
            specified date(s) indicated in your mobile app and website
            Application Form.
          </p>

          <p>
            Furthermore, you acknowledge and agree that the Company retains the
            right to track your location while you are utilizing the Services,
            even after you cease using the Services, uninstall the mobile app,
            or delete any related components. This tracking will continue until
            you have fulfilled all your obligations, including settling the
            outstanding amount owed to the Lender. You also consent to the
            Company's ongoing location tracking in the event that you
            discontinue using the Services, uninstall the mobile app, or cease
            utilizing any other associated features.
          </p>

          <p>
            In the event that you uninstall or discontinue using our Services,
            you are still responsible for settling any outstanding amounts. It
            is important to note that you are solely accountable for any actions
            taken using your User Account, and the Company cannot be held liable
            for any consequences arising after your use of the Services. You
            agree to maintain the confidentiality of your User Account and are
            required to possess compatible devices and an internet connection
            that are compatible with the Platform and Services. The Company
            reserves the right to reject or approve your registration without
            prior notice. When you register, the Company stores your User Data.
            You are not required to log in each time you access or use the
            Platform. By agreeing to these Terms, you grant us permission to
            track, download, and utilize your User Data, including Personal
            Data, for authentication purposes and to facilitate updates to your
            credentials.
          </p>

          <b>LICENCE:</b>
          <p>
            To utilize the Services, you must download and install the app. By
            accessing and using the Services, you confirm that you are of legal
            age and possess the ability to understand, agree to, and abide by
            these Terms. You are granted a limited right to download, install,
            access, and use the App on your mobile phone, tablet, or other
            compatible devices. While the Company reserves the right to provide
            maintenance and support, it is not obligated to do so. You have the
            option to subscribe to updates and upgrades through the Online
            Stores. However, if you choose not to update or upgrade, certain
            features or functions may not be available to you. It is important
            to note that the App is licensed to you, not sold, and you may only
            use it in accordance with these Terms.
          </p>

          <b>RESTRICTIONS:</b>
          <p>
            By using our Platform and Services, you agree to the following terms
            and conditions: You must not engage in fraudulent activities or
            misuse the Platform for illegal purposes. Copying, selling, or
            reselling any part of the Platform is strictly prohibited.
            Additionally, you are not allowed to upload prohibited content or
            engage in behavior that is harmful, threatening, abusive, harassing,
            or offensive. Impersonating others or manipulating content origins
            is prohibited. Unsolicited advertising, spam, or any form of
            unauthorized solicitation on the Platform is not allowed. Uploading
            or distributing malicious software or engaging in activities that
            disrupt or damage the Platform or associated networks is strictly
            prohibited. You must also comply with all applicable laws and
            regulations.
          </p>

          <p>
            Don't upload anything that contains software viruses or any computer
            code, files, or programmes that are designed to disrupt, damage, or
            limit the performance of any computer software, hardware, or
            telecommunications equipment available on the Platform. Don't do
            anything that stops people from talking to each other or
            participating in live discussions. Don't try to sabotage the
            Platform, any networks connected to it, or any rules and regulations
            that these networks have set. And don't break any laws or
            regulations that have the force of law, either intentionally or
            unintentionally.
          </p>

          <b>CONTENT AVAILABLE:</b>
          <p>
            Please note that while using our Platform, we do not make any
            warranties regarding the available content, including data files,
            text, software, audio files, images, or videos. We are not
            responsible for any content posted or made available through the
            Platform, unless specifically stated otherwise in these Terms.
          </p>

          <b>PROPRIETARY RIGHTS OF THE COMPANY:</b>
          <p>
            By registering with us, you grant us full rights, including
            intellectual property rights, to the content and Platform. You also
            agree to respect and use any logos, service marks, or trademarks
            associated with our Platform. Unauthorized use of such intellectual
            property may violate applicable laws. Please be aware that your
            registration implies your commitment to utilizing our services.
          </p>

          <b>LINKS TO THIRD-PARTY SITES:</b>
          <p>
            The Platform may contain links to external websites owned and
            operated by third parties that are not affiliated with us. Please
            note that these third-party sites are independent of the Platform
            and beyond our control. We do not provide any representations or
            warranties regarding the content of these sites. The inclusion of
            these links is solely for your convenience and does not imply
            endorsement by the Company. Your decision to access or utilize these
            sites is entirely at your own discretion, and the Company bears no
            responsibility in this regard.
          </p>

          <b>Third-Party Advertisements:</b>
          <p>
            The presence of third-party advertisements on the Platform does not
            indicate our endorsement or recommendation of the advertised
            products or services. If you are interested in any of these
            offerings, it is advisable to directly engage with the respective
            advertisers to obtain the necessary information. Please be aware
            that any interactions or transactions you have with third-party
            advertisers are your sole responsibility, and the Company cannot be
            held liable for any outcomes or consequences arising from such
            interactions.
          </p>

          <b>ANCILLARY SERVICES:</b>
          <p>
            The Platform may provide additional services, such as chat rooms,
            blogs, feedback and review sections, and other periodic offerings.
            These services are either operated by us or by third parties acting
            on our behalf. It is strictly prohibited to use these services, or
            permit others to use them, for any illegal activities, including
            defamation, abuse, harassment, stalking, threatening behaviour,
            racism, or any other violation of legal rights. The Platform may
            also feature advice, opinions, and statements from experts or
            analysts. However, we do not guarantee the accuracy or reliability
            of such content. It is your responsibility to assess the legitimacy
            and usefulness of any advice, opinion, service, statement, or
            information provided on the Platform before relying on it. The
            information presented on the Platform does not constitute legal,
            financial, tax, investment, or any other form of professional
            advice. It is of a general nature and does not pertain to specific
            circumstances. We reserve the right to modify, edit, alter, or
            delete any information on the Platform at our discretion, and we
            shall not be held liable for any claims or losses arising from such
            changes. Nothing on the Platform should be construed as a
            recommendation, and we do not warrant that the use of any content on
            the Platform will not infringe upon any patents or other rights.
          </p>

          <b>TERMINATION:</b>
          <p>
            The Company reserves the right to terminate these Terms under
            specific circumstances, including but not limited to:
          </p>

          <p>
            • Your violation of any of these Terms.• Our legal obligations. •
            Our decision to discontinue providing the Services or operating the
            Platform. • Expiration of your license to use the App. • Failure to
            settle the outstanding amount may result in the Company continuing
            to monitor your activities even after the termination of these Terms
            or the uninstallation of the App until all debts, including the
            outstanding amount, are fully paid. Failure to make the necessary
            payments will result in the forfeiture of all rights and licenses
            granted under these Terms, and you must immediately cease using the
            Platform and Services while fulfilling your outstanding obligations.
          </p>

          <p>
            Please note that the above information has been summarized for
            clarity and convenience. For a comprehensive understanding of the
            Terms and Conditions, we strongly advise reviewing the entire
            document. If you have any questions or concerns, please feel free to
            contact us.
          </p>

          <b>Disclaimer of Warranties:</b>
          <p>
            By utilizing the Services and Platform, you acknowledge and agree
            that you are doing so at your own risk. The Services and Platform
            are provided on an "as is" and "as available" basis. The Company
            does not provide any express or implied warranties, including but
            not limited to warranties of merchantability, fitness for a
            particular purpose, or non-infringement of intellectual property
            rights. Any materials downloaded or acquired through the Platform
            are solely at your discretion and are subject to your own risk. You
            are responsible for any damages to your computer system or loss of
            electronic data resulting from the download of such materials. If
            you rely on advice or information from the Company, whether provided
            in writing or orally, and subsequently use the Services or Platform,
            you assume full responsibility for any misuse or abuse of the
            Services. The Company shall not be held liable for any damages
            arising from the use of the Services that are not explicitly stated
            in these Terms. We do not guarantee that the Content will be
            comprehensive, complete, or accurate, nor do we guarantee that the
            Services or Platform will be consistently available, rapid, secure,
            or free from errors. Furthermore, we do not guarantee the accuracy
            or reliability of the results obtained from the use of the Services
            or Platform.
          </p>

          <b>Indemnity:</b>
          <p>
            By agreeing to this Agreement, you agree to indemnify and hold
            harmless the Company, its subsidiaries and affiliates, officers,
            employees, agents, co-branders, other partners, and representatives
            from any third-party claims or demands, including attorneys' fees,
            arising from: (i) your failure to comply with these Terms. (ii) your
            infringement of other users' rights. (iii) your unauthorized use or
            misuse of the Platform or Services. (iv) any violation of applicable
            laws and regulations.{" "}
          </p>

          <b>Limitations of Liability:</b>
          <p>
            You acknowledge and accept that the Company, its directors,
            employees, agents, or service providers shall not be liable for any
            damages, whether direct, indirect, incidental, special,
            consequential, or exemplary (even if the Company has been advised of
            the possibility of such damages), arising from: (a) the non-use or
            inability to use the Services; (b) the inability to access the
            Platform; (c) delays in the provision of Services or unavailability
            of the Platform; (d) performance issues or failure to meet
            expectations; (e) damage or virus infection to your computer or
            other devices resulting from the use of the Platform or downloading
            materials from the Platform; (f) server issues or other problems
            related to the Services.
          </p>

          <b>Force Majeure:</b>
          <p>
            Notwithstanding anything to the contrary, the Company shall not be
            held liable, under any circumstances, for any damages, losses, or
            disruptions suffered by the Platform due to the non-delivery of the
            Services, directly or indirectly, as a result of natural events,
            forces, or causes beyond the reasonable control of the Company. Such
            events may include, but are not limited to, internet failure,
            computer equipment failure, telecommunication equipment failure,
            changes in regulations imposed by the Reserve Bank of India or any
            other government body, riots, storms, civil disturbances, electrical
            failure, floods, and other similar occurrences.
          </p>

          <b>Cancellation & Refund Policy:</b>
          <p>
            By using our Services, you agree to our Cancellation & Refund
            Policy. Please take a moment to familiarize yourself with the
            details below, outlining our commitment to fairness and
            customer-centric practices.
          </p>
          <p>
            (i) Pre-Disbursement Cancellation: Cancellation is allowed if the
            loan has been sanctioned but not disbursed. (ii) Cancellation After
            Disbursement: If the applicant wishes to cancel the service after
            loan disbursement within 24 hours, the principal amount must be
            repaid. (iii) Refund of Excess Payments: Any Excess payments made
            will be refunded within 5-7 days after the reconciliation of loan
            repayment. (iv) The company will not allow multiple partial
            payments. Any partial payment of a loan, including those towards
            foreclosure, must be made in a single transaction, covering both the
            principal and the interest accrued up to that day.
          </p>

          <b>Privacy Policy:</b>
          <p>
            We collect, share, and process Personal Information in accordance
            with our Privacy Policy, which outlines the purposes and practices
            of our data handling procedures. For detailed information, please
            refer to our Privacy Policy available on our website. Changes: The
            Company reserves the right to update these Terms and any associated
            information on the Platform at any time. Such updates shall become
            effective immediately upon their posting. By continuing to use the
            Services or Platform after these updates have been made, you
            acknowledge and accept the revised Terms as your ongoing agreement.
          </p>

          <b>Choice of Law and Jurisdiction:</b>
          <p>
            This Agreement shall be construed as a legally binding contract and
            shall be governed by the laws of the State of India, irrespective of
            any principles of conflict of laws. The Parties agree that any
            disputes arising from or in connection with this Agreement shall be
            exclusively resolved by the courts located in the State of Delhi.
          </p>

          <b>Miscellaneous:</b>
          <p>
            By using our Services, you agree to the Terms and Loan Agreement,
            mobile app and website Application Form, and Privacy Policy. These
            documents constitute the complete agreement between you and the
            Company. The Company retains the right to enforce any rights and
            provisions outlined in these Terms, even if they have not been
            exercised previously. Any claims or causes of action arising from
            the Services or Terms must be filed within one year from the date of
            first use, or they will be deemed permanently barred. If any part of
            the Terms is deemed invalid by a court, the remaining terms will
            continue to be upheld to the fullest extent.
          </p>

          <b>Violations:</b>
          <p>
            If you encounter any concerns or complaints regarding these Terms,
            please don't hesitate to reach out to us at info@afiloans.co.in We
            are committed to addressing any issues promptly and ensuring your
            satisfaction.
          </p>
        </div>
      </div>
    </>
  );
};
